import script from "./FileModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FileModal.vue?vue&type=script&setup=true&lang=js"

import "./FileModal.vue?vue&type=style&index=0&id=2e7f714a&lang=css"

const __exports__ = script;

export default __exports__